import {
  createReqConsts,
  createActions,
  createReqReducer,
  createReqWatcher,
} from '../../../utils/redux';

export const consts = createReqConsts(
  'patient-portal',
  'patient-channels-for-share',
);
export const actions = createActions(consts);
export const watcher = createReqWatcher(consts, actions, {
  endpoint: 'channels',
  type: 'get',
  slug: [
    {
      type: 'payload.query',
      queryParameter: 'type',
      selector: 'type',
    },
    {
      type: 'payload.query',
      queryParameter: 'limit',
      selector: 'limit',
    },
    {
      type: 'payload.query',
      queryParameter: 'offset',
      selector: 'offset',
    },
  ],
});

export default createReqReducer(consts);



// WEBPACK FOOTER //
// ./src/redux/healthboard/patientPortal/patient-channels-for-share.js